<div class="pw-stepper-row">
  <button type="button" class="pw-step-btn" (click)="decrease()" [disabled]="decDisabled" [attr.aria-label]="'Decrease seats'">
    <svg width="16" height="16" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M2 7H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
    </svg>
  </button>
  <input
    class="pw-qty-input"
    type="number"
    inputmode="numeric"
    [value]="quantity()"
    [min]="min()"
    [max]="max()"
    [attr.aria-label]="ariaLabel()"
    (input)="onTyping($event)"
    (blur)="onCommit($event)"
    (keydown)="onKeyDown($event)">
  <button type="button" class="pw-step-btn" (click)="increase()" [disabled]="incDisabled" [attr.aria-label]="'Increase seats'">
    <svg width="16" height="16" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M7 2V12M2 7H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
    </svg>
  </button>
</div>
@if (helper()) {
  <p class="pw-qty-label">{{ helper() }}</p>
}
